var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hex",style:({'width':_vm.width})},[_c('span',{staticClass:"hexIn"},[(_vm.imgUrl)?_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}):_c('img',{staticClass:"playerHead",attrs:{"src":require("../assets/img/updateImg/playerHead.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }